module.exports = __webpack_public_path__ + "school/img/yidaiyilu.95637a02.jpg";